<template>
    <div class="device-type-manange relative">
        <div class="buttons" v-if="role_id != 2">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'hospitalAdd'" @click="addDoctor">新增</el-button>
            <el-button  @click="getExpertInfo">导出资料</el-button>
        </div>


        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="6" :xl="5" :sm="8" :xs="8">
                <span class="fs-14 pd-r-10">健康管理助理姓名：</span>
                <el-input v-model="user_name" placeholder="健康管理助理姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;单位：</span>
                <el-select v-model="hospital_id" placeholder="请选择单位">
                    <el-option
                        v-for="item in allHospital"
                        :key="item.id"
                        :label="item.hospital_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="9" :xl="6" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">签约时间：</span>
                <el-date-picker
                        v-model="search_expired_date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="6" :xl="5" :sm="8" :xs="8">
                <span class="fs-14 pd-r-10">健康管理手机号码：</span>
                <el-input v-model="mobile" placeholder="手机号码模糊搜素"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">健康管理助理职称：</span>
                <div>
                    <el-select v-model="title_id" placeholder="请选择单位">
                        <el-option
                            v-for="item in allTitle"
                            :key="item.id"
                            :label="item.title_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div>

            </el-col>
            <el-col :md="6" :lg="6" :xl="6" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">状&ensp;&ensp;&ensp;&ensp;态：</span>
                <el-select class="status" v-model="status" placeholder="请选择状态" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row >
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="6" :xl="5" :sm="8" :xs="8">
                <span class="fs-14 pd-r-10">绑定健康管理专家：</span>
                <el-input v-model="doctor_name" placeholder="绑定健康管理专家模糊搜索"/>
            </el-col>


        </el-row>
        <!-- 表单结束 -->
         <div class="docker_buttons" v-if="role_id != 2">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="50" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="user_name" label="健康管理助理姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="mobile" label="登录手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="doctor_name" label="绑定健康管理专家" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="doctor_mobile" label="健康管理专家手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="hospital_name" label="单位" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="title_name" label="职称" align="center" label-class-name="label"></el-table-column>
<!--            <el-table-column prop="company_name" label="所属公司" align="center" label-class-name="label"></el-table-column>-->
<!--            <el-table-column prop="department_name" label="所属部门" align="center"-->
<!--                             label-class-name="label"></el-table-column>-->
<!--            <el-table-column prop="group_name" label="所属组" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="admin_user_name" label="运营负责人" v-if="role_id != 2 && child_role_id == 0" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="110" prop="admin_user_mobile" label="负责人电话" v-if="role_id != 2 && child_role_id == 0" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="client_total" label="服务健康管理对象数" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="start_date" label="签约时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="60" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="70" prop="clockin" label="确认接待记录" align="center" label-class-name="label">
                <template slot-scope="scope">
                <el-button :id="'managerDel'" @click="goClockinList(scope.row)" type="text"
                           size="small">查看
                </el-button>
                </template>
            </el-table-column>
            <el-table-column width="180"
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'managerEdit'" @click="goEdit(scope.row)" type="text" size="small" v-if="role_id != 2">
                    编辑
                </el-button>
                <el-button :id="'managerDetail'" @click="goDetail(scope.row)" type="text" size="small">
                    详情
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopDoctor(scope.row,2)" v-if="role_id != 2 && scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopDoctor(scope.row,1)" v-if="role_id != 2 && scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'hospitalDel'" @click="resetPassword(scope.row)" type="text" v-if="role_id != 2"
                           size="small">重置密码
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show && role_id != 2"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import {export2Excel} from "@/utils/excel";
    import {getUserInfos} from "@/utils/userInfos";
    import {authUrlCheck, base64Parser, getBase64Image, loadFile} from "@/api/order";
    import PizZip from "pizzip";
    import Docxtemplater from "docxtemplater";
    import {saveAs} from "file-saver";
    import ImageModule from "docxtemplater-image-module-free";
    import env from "@/api/env";
    export default {
        data() {
            return {
                role_id: 0,
                child_role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                doctor_name: '',
                mobile: '',
                company_id: '',
                company_group_id: '',
                hospital_id: '',
                title_id: '', // 健康管理助理职称id
                status: '',
                company_department_id: '',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                allCompany: [],
                allCompanyDepartment: [],
                allCompanyGroup: [],
                allCompanyList: [],
                allCompanyDepartmentList: [],
                allCompanyGroupList: [],
                allHospital: [],
                allTitle: [], // 所有健康管理助理职称
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                is_submit: false,
                is_pagination_show: true
            };
        },
        created() {

            let userInfo = getUserInfos()
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
            // if (this.$route.params.hospital_department_id) {
            //     this.hospital_department_id = this.$route.params.hospital_department_id;
            // }
        },
        mounted() {
            let prev_page = localStorage.getItem('prev_page');
            if (prev_page == 'manager_add' || prev_page == 'manager_edit' || prev_page == 'manager_detail') {
                this.user_name = localStorage.getItem('manager_list_user_name')
                this.mobile = localStorage.getItem('manager_list_mobile')
                this.company_id = localStorage.getItem('manager_list_company_id')
                this.company_group_id = localStorage.getItem('manager_list_company_group_id')
                this.company_department_id = localStorage.getItem('manager_list_company_department_id')
                this.status = parseInt(localStorage.getItem('manager_list_status'))||''
                this.start_date = localStorage.getItem('manager_list_start_date')
                this.end_date = localStorage.getItem('manager_list_end_date')
                this.doctor_name = localStorage.getItem('manager_list_doctor_name')
                this.title_id = localStorage.getItem('manager_list_title_id')
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                this.search_expired_date = [this.start_date, this.end_date]
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.mobile == 'undefined' || this.mobile == 'null') {
                    this.mobile = ''
                }
                if (this.company_id == 'undefined' || this.company_id == 'null') {
                    this.company_id = ''
                }
                if (this.company_group_id == 'undefined' || this.company_group_id == 'null') {
                    this.company_group_id = ''
                }
                if (this.company_department_id == 'undefined' || this.company_department_id == 'null') {
                    this.company_department_id = ''
                }
                if (this.status == 'undefined' || this.status == 'null') {
                    this.status = ''
                }
                if (this.start_date == 'undefined' || this.start_date == 'null') {
                    this.start_date = ''
                }
                if (this.end_date == 'undefined' || this.end_date == 'null') {
                    this.end_date = ''
                }
                if (this.doctor_name == 'undefined' || this.doctor_name == 'null') {
                    this.doctor_name = ''
                }
                if (this.title_id == 'undefined' || this.title_id == 'null') {
                    this.title_id = ''
                }
                this.is_pagination_show = false

            }
            this.getList();

            this.listParams();
        },
        methods: {
            // 获取所有设备类型
            getList() {
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'assistantList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        company_id: this.company_id,
                        company_group_id: this.company_group_id,
                        company_department_id: this.company_department_id,
                        status: this.status,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        doctor_name: this.doctor_name,
                        hospital_id: this.hospital_id,
                        title_id: this.title_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;

                    localStorage.setItem('manager_list_user_name', this.user_name)
                    localStorage.setItem('manager_list_mobile', this.mobile)
                    localStorage.setItem('manager_list_company_id', this.company_id)
                    localStorage.setItem('manager_list_company_group_id', this.company_group_id)
                    localStorage.setItem('manager_list_company_department_id', this.company_department_id)
                    localStorage.setItem('manager_list_status', this.status)
                    localStorage.setItem('manager_list_start_date', this.start_date)
                    localStorage.setItem('manager_list_end_date', this.end_date)
                    localStorage.setItem('manager_list_doctor_name', this.doctor_name)
                    localStorage.setItem('manager_list_hospital_id', this.hospital_id)
                    localStorage.setItem('manager_list_title_id', this.title_id)
                    localStorage.setItem('prev_page', 'manager_list')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    this.is_pagination_show = true
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            listParams() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'managerListParams',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        company_id: this.company_id,
                        department_id: this.company_department_id,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    // this.allCompany = res.data.data.company;
                    // this.allCompanyDepartmentList = res.data.data.deparment;
                    // this.allCompanyGroupList = res.data.data.group;
                    this.allHospital = res.data.data.hospital;
                    this.allTitle = res.data.data.managerTitle;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_name = "";
                this.mobile = "";
                this.company_id = "";
                this.hospital_id = "";
                this.title_id = "";
                this.company_group_id = "";
                this.company_department_id = "";
                this.status = "";
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.page = 1;
                this.getList();
                this.listParams();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }

                this.page = 1;
                this.getList();
            },

            // 跳转添加页
            addDoctor() {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/manager/ManagerAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({name: "managerAdd", params: {}});
                return;
            },

            // 跳转编辑页
            goEdit(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/manager/ManagerEdit', this.$store.getters.authUrl)) {
                        return;
                    }
                }

                this.$router.push({
                    name: "managerEdit",
                    params: {
                        user_id: data.user_id,
                    }
                });
                return;
            },

            // 跳转详情页
            goDetail(data) {
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/manager/ManagerDetail', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "managerDetail",
                    query: {
                        user_id: data.user_id,
                    }
                });
                // this.$router.push({
                //     name: "managerDetail",
                //     params: {
                //         user_id: data.user_id,
                //         user_name: data.user_name,
                //         mobile: data.mobile,
                //         company_name: data.company_name,
                //         company_department_name: data.department_name,
                //         company_group_name: data.group_name,
                //         status: parseInt(data.status_number),
                //     }
                // });
                return;
            },

            // 启用停用健康管理助理
            startStopDoctor(data, status) {
                if (status == '1') {
                    var message = '确定启用该健康管理助理吗？';
                }
                if (status == '2') {
                    var message = '确定停用该健康管理助理吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AssistantAdminServices',
                        method: 'assistantOperation',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.user_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message.success('修改成功');

                    
                         if (status == '1') {
                              data.status = '启用';
                              data.status_number = 1;
                         }else
                         {
                             data.status = "停用";
                              data.status_number = 2;
                         }
                        //this.getList();
                    });
                }).catch(() => {
                });
            },

            // 重置密码
            resetPassword(data) {
                this.$confirm('确定重置该健康管理助理的密码吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AssistantAdminServices',
                        method: 'resetUserPawssword',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            user_id: data.user_id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '重置成功',
                            duration: 1500,
                        });
                    });
                }).catch(() => {
                });
            },

            changeCompany() {
                this.company_department_id = "";
                this.company_group_id = "";
                let department = [];
                this.allCompanyDepartmentList.forEach(element => {
                    if(element.company_id == this.company_id)
                    {
                        department.push(element);
                    }
                });
                this.allCompanyDepartment = department;
                //this.listParams();
            },

            changeCompanyDeparment() {
               // this.listParams();
               this.company_group_id = "";
               let group = [];
                this.allCompanyGroupList.forEach(element => {
                    if(element.department_id == this.company_department_id)
                    {
                        group.push(element);
                    }
                });
                this.allCompanyGroup = group;
            },

            goClockinList(data) {
                this.$router.push({
                    name: "ReceptionList", params: {
                        user_id: data.user_id,
                        user_name:data.user_name
                    }
                });
            },
            // 导出数据
        exportExcel() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
                let params = {
                servername: 'Ruyi_AssistantAdminServices',
                    method: 'exportAssistantList',
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                        user_name: this.user_name,
                        mobile: this.mobile,
                        company_id: this.company_id,
                        company_group_id: this.company_group_id,
                        company_department_id: this.company_department_id,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        doctor_name: this.doctor_name
                    },
                };

                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "健康管理助理姓名", key: "user_name"},
                    {title: "登录手机号码", key: "mobile"},
                    {title: "所属公司", key: "company_name"},
                    {title: "所属部门", key: "department_name"},
                    {title: "所属组", key: "group_name"},
                    {title: "服务健康管理对象数", key: "client_total"},
                    {title: "创建时间", key: "create_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    if (!res.data.data) {
                        this.$message({
                            type: "error",
                            message: '没有符合条件的数据！'
                        });
                        this.is_submit = false;
                        return
                    }
                    for (var i = 0; i < res.data.data.length; i++) {
                        switch (res.data.data[i].status) {
                            case '1':
                                res.data.data[i].status = '启用';
                                break;
                            case '2':
                                res.data.data[i].status = '停用';
                                break;
                        
                        }

                        let item = {
                            id: res.data.data[i].user_id,
                            user_name: res.data.data[i].user_name,
                            mobile: res.data.data[i].mobile,
                            company_name: res.data.data[i].company_name,
                            department_name: res.data.data[i].department_name,
                            group_name: res.data.data[i].group_name,
                            client_total: res.data.data[i].client_total,
                            create_date: res.data.data[i].create_date,
                            status: res.data.data[i].status,
                        };
                        export_data.push(item);


                    }

                    
                    export2Excel(colums_list, export_data, "健康管理助理记录");
                    let _that = this
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 获取健康管理助理资料资料
            getExpertInfo() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'expertListing',
                    params: {
                        user_name: this.user_name,
                        mobile: this.mobile,
                        company_id: this.company_id,
                        company_group_id: this.company_group_id,
                        company_department_id: this.company_department_id,
                        status: this.status,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        doctor_name: this.doctor_name,
                        hospital_id: this.hospital_id,
                        title_id: this.title_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.all_expert = res.data.data
                    let _that = this
                    this.importinfo(res.data.data)
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 健康管理助理资料导出到word
            async importinfo(data) {
                let newDataArr = [];
                let doctors = [];
                let users = [];
                let contracts = [];
                let type_name = '';
                let doctor_status = '';
                for (let k = 0; k < data.length; k++) {
                    doctors = [];
                    users = [];
                    contracts = [];
                    type_name = '';
                    // 健康管理专家
                    if (data[k].bindedDoctor) {
                        doctors.push({
                            name: data[k].bindedDoctor.user_name,
                            mobile: data[k].bindedDoctor.mobile,
                            status: data[k].bindedDoctor.status == 1 ? '启用':'停用',
                            hospital: data[k].bindedDoctor.hospital_name,
                            department: data[k].bindedDoctor.department_name,
                        })
                    }

                    // 健康管理对象
                    if (data[k].customerList && data[k].customerList.length > 0) {
                        for (let i=0; i< data[k].customerList.length;i++) {
                            users.push({
                                name: data[k].customerList[i].user_name,
                                mobile: data[k].customerList[i].mobile,
                                start_date: data[k].customerList[i].start_date,
                                end_date: data[k].customerList[i].expired_date,
                            })
                        }
                    }

                    // 签约记录
                    if (data[k].allContract && data[k].allContract.length > 0) {
                        for (let i=0; i< data[k].allContract.length;i++) {
                            type_name = data[k].allContract[i].contract_type == "1" ? '新约' : '续约';
                            contracts.push({
                                type: type_name,
                                start_date: data[k].allContract[i].start_date,
                                end_date: data[k].allContract[i].expired_date,
                            })
                        }
                    }
                    let doctor_status = '';
                    if (data[k].manager.doctor_id) {
                        doctor_status = data[k].manager.doctor_status == 1 ? '启用' : '停用';
                    }
                    newDataArr.push({
                        "avatar": await getBase64Image(env.IMG_COMMON_URL_PREFIX + data[k].manager.user_avatar),
                        "user_name": data[k].manager.user_name,
                        "status": data[k].manager.status == 1 ? '启用' : '停用',
                        "hospital_name": data[k].manager.hospital_name || ' ',
                        "title_name": data[k].manager.title_nam || ' ',
                        "doctor_name": data[k].manager.doctor_name || ' ',
                        "doctor_status": doctor_status,
                        "doctor_mobile": data[k].manager.doctor_mobile || ' ',
                        "idcard": data[k].manager.idcard || ' ',
                        "company_name": data[k].manager.company_name || ' ',
                        "mobile": data[k].manager.mobile || ' ',
                        "department": data[k].manager.department_name || ' ',
                        "expired_date": data[k].manager.expired_date || ' ',
                        "group": data[k].manager.group_name || ' ',
                        "need_deal_num": data[k].manager.needDeal || 0,
                        "no_reply_num": data[k].manager.noReplyCount || 0,
                        "before_meet_num": data[k].manager.beforeMeetCount || 0,
                        "int_num": data[k].manager.brokenMeetCount || 0,
                        "succ_num": data[k].manager.finishMeet || 0,
                        "doctor": doctors,
                        "user": users,
                        "contracts": contracts,
                    })
                }

                
                loadFile(
                    "detail-manager.docx",
                    function (error, content) {

                        if (error) {
                            this.is_submit = false;
                            throw error;
                        }

                        const zip = new PizZip(content);

                        let imageOpts = {}
                        imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                        imageOpts.fileType = "docx";
                        imageOpts.getImage = function (newImgUrl) {
                            return base64Parser(newImgUrl);
                        }
                        imageOpts.getSize = function () {
                            return [190, 190]
                        }

                        const doc = new Docxtemplater(zip, {
                            paragraphLoop: true,
                            linebreaks: true,
                            modules: [new ImageModule(imageOpts)],
                        });

                        doc.render({
                            "manager_info": newDataArr
                        });

                        const out = doc.getZip().generate({
                            type: "blob",
                            mimeType:
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                        });
                        // Output the document using Data-URI
                        saveAs(out, `健康管理助理资料.docx`);

                    }
                );

            }
        },
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

     .docker_buttons {
        float: right;
        margin: 10px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }

    .inputs .el-select.status .el-input {
        width: 100%;
    }
</style>
